export const extractOnlyTwoDigitDate = (timestamp) => {
  const dateObject = new Date(timestamp);
  return dateObject.toLocaleDateString("en-US", { day: "2-digit" });
};
//output is 01 or 02 that is for date in two digit
